/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsBaseForGitHub extends models.ServiceAccountCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForGitHub");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsBaseForGitHub.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsBaseForGitHub>): ServiceAccountCredentialsBaseForGitHub {
        let obj = Object.assign(new ServiceAccountCredentialsBaseForGitHub(), model);
        ServiceAccountCredentialsBaseForGitHub.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsBaseForGitHub>): ServiceAccountCredentialsBaseForGitHub {
        if (!model) return null;
        return ServiceAccountCredentialsBaseForGitHub.newInstance(<ServiceAccountCredentialsBaseForGitHub> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsBaseForGitHub) {
        if (!obj) return;

        models.ServiceAccountCredentialsBaseForGitHub.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsBaseForGitHub): boolean {
        if (models.ServiceAccountCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsBaseForGitHub.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * URL for the authentication.
     */
    auth_url: string;

    /**
     * Entity Name. This is a required field. Enter the organization name or Enterprise name based on the scope which has been selected.
     */
    entity_name: string;

}
